/** @format */

import React from 'react'
import { Link } from 'react-router-dom'

import styles from './button.module.scss'

export const Button = ({ value, link, event }) => {
  const handleValue = (e) => {
    e.preventDefault()
    event()
  }

  return (
    <div className={styles.wrapper}>
      {!!link ? (
        <Link className={styles.button} to={link} onClick={event}>
          {value}
        </Link>
      ) : (
        <button onClick={handleValue} className={styles.button}>
          {value}
        </button>
      )}
    </div>
  )
}
